module.exports = __webpack_public_path__ + "img/undraw_schedule_pnbk.57b81397.svg";